module.exports = __webpack_public_path__ + "static/media/sankhya.0f2c3910.png";